import React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Modal, Button, Row, Col, message, Icon, AutoComplete, } from 'antd';
import { invoiceInput } from 'src/api';
import debounce from 'lodash/debounce';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
const confirm = Modal.confirm;
interface UserFormProps extends FormComponentProps {
    onCloseModal: () => void;
    onSwitchHandler: (values: any) => void;
    rows: any;
}
class Component extends React.Component<any, any> {
    //添加到发票组界面
    constructor(props: UserFormProps) {
        super(props);
        this.state = {
            list: null,
            info: true,
            groupNumber: null
        };
    }
    onCloseModal = () => {
        this.props.onCloseModal();
    }
    fetchGroup = (value) => {
        const groupNumber = value;
       
        if (groupNumber) {
            invoiceInput.GetGroupList(this, { groupNumber }).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        this.setState({
                            list: res
                        });
                    }
                }
            });
        }
    }
    componentDidMount() {
        this.props.form.validateFields();
    }
    beforeHandle = (e) => {
        e.preventDefault();
        let groupNumber=this.props.form.getFieldValue('groupNumber');
        this.setState({
            groupNumber
        });
        const { rows } = this.props;
        const selectedRows=rows.filter((item) => item.recordType === 1);
        confirm({
            title: '提示',
            content: <div><p>是否确定移动 {selectedRows.length} 张发票至 {groupNumber} 发票组？</p>移动后，不可撤销！</div>,
            onOk: () => {
                this.handleSubmit();
            },
            onCancel() { },
        });
    }
    handleSubmit = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSwitchHandler(values);
                this.props.onCloseModal();
            }
        });
    }
    onAddGroup = () => {
        invoiceInput.CreatGroup(this, {}).then((response: any) => {
            const res = response.res;
            if (res) {
                message.success('操作成功');
                this.props.form.setFieldsValue({ groupNumber: res });
            }
        });
    }
    hasErrors = (fieldsError) => {
        return Object.keys(fieldsError).some(field => fieldsError[field]);
    }
    render() {
        const { getFieldDecorator, getFieldsError } = this.props.form;
        const { list, info } = this.state;
        const data = list && list.map((item, index) => {
            return <Option key={item.groupNumber} title={item.groupNumber}>{item.groupNumber}</Option>;
        });
        return (
            <Modal
                visible={true}
                onCancel={this.props.onCloseModal}
                footer={null}
                title="添加到发票组"
            >
                <Form onSubmit={this.beforeHandle}>
                    <Row>
                        <Col span={21} >
                            <FormItem
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 18 }}
                                label="发票组编号"
                            >
                                {getFieldDecorator('groupNumber', {
                                    rules: [{ required: true, message: '请输入编号(最大长度36位)', max: 36 }]
                                })(
                                    <AutoComplete onSearch={this.fetchGroup}>
                                        {data}
                                    </AutoComplete>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={2} offset={1}>
                            <span style={{ lineHeight: '39px' }} className="hand" onClick={this.onAddGroup}><Icon type="plus" /></span>
                        </Col>
                    </Row>
                    <div style={{ 'textAlign': 'center' }}>
                        <Button disabled={this.hasErrors(getFieldsError())} type="primary" htmlType="submit">提交</Button>
                    </div>
                </Form>
            </Modal>
        );
    }

}
const WrappedModalForm = Form.create()(Component);
export default WrappedModalForm as any;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.SwitchGroup.tsx